import { FormLayoutBuilder, getFormData } from '@pihealth/common-ui-library';
import Loader from 'src/components/common/Loader';
import { Box, Grid, Typography } from '@mui/material';
import AppModal from 'src/components/modal';
import staticData from '../../../resources/static.json';
import forms from '../../../resources/forms.json';
import { useRef } from 'react';
import { ReactComponent as LongArrow } from './longArrow.svg';
import { useAppSelector } from 'src/store/hooks';
import { AppState } from 'src/store';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
const ShippedDialog: React.FunctionComponent<any> = props => {
  const { openShipped, setOpenShipped } = props;
  const shippedData = staticData.RequestToShipment.shippedData;
  const formGroup = forms.shippedDrugSupply;
  const { formFields, rules } = getFormData(formGroup.groups);
  const shipData: any = useAppSelector((state: AppState) => state.drugSupplySlice.shippedData);
  const formRef: any = useRef(null);
  const { groups } = formFields;
  const { preferedDateFormat } = usePreferedDateFormat();
  const handleCloseShipped = () => {
    setOpenShipped(false);
  };
  return (
    <>
      <AppModal
        open={openShipped}
        title={`${formGroup.header} - ${preferedDateFormat(shipData?.date_of_shipment)}`}
        closeButton={'Close'}
        handleClose={() => handleCloseShipped()}
        maxWidth="600px"
        hideModalSaveButton
        outSideClickClose
      >
        <Loader />
        <Grid container spacing={2} rowSpacing={1} mb="24px">
          {shippedData.map((ele: any, index: number) => (
            <Grid item md={6} key={index}>
              <Typography variant="body1" sx={{ fontSize: 'clamp(14px, 15px, 16px)', wordBreak: "break-word" }}>
                <strong style={{ display: 'inline-block', minWidth: 'fit-content'}}>{ele.textValue}:&nbsp;</strong>
                <span className="results">{shipData?.[ele.value]}</span>
              </Typography>
            </Grid>
          ))}
        </Grid>
        <FormLayoutBuilder initialValues={shipData} rules={rules} ref={formRef} groups={groups} columnSpacing={2} />
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', columnGap: 1, my: 4 }}>
          <Box sx={{ minWidth: '116px', textAlign: 'center' }}>
            <Typography variant="body1" gutterBottom>
              <strong>
                {shipData?.depot_name} <br />[{shipData?.depot_id}]
              </strong>
            </Typography>
            <Typography variant="body2" sx={{ fontSize: 'clamp(12px, 13px, 14px)' }}>
              <span className="results">
                Shipped on
                <br />
                {preferedDateFormat(shipData?.date_of_shipment)}
              </span>
            </Typography>
          </Box>
          <Box
            sx={{
              minWidth: '296px',
              display: 'flex',
              alignItems: 'flex-end',
              overflow: 'hidden',
              '& svg path': { fill: 'black' }
            }}
          >
            <LongArrow />
          </Box>
          <Box sx={{ minWidth: '116px', textAlign: 'center' }}>
            <Typography variant="body1" gutterBottom>
              <strong>
                {shipData?.transfer_to.split(' - ')?.[0]} <br />[{shipData?.transfer_to.split(' - ')?.[1]}]
              </strong>
            </Typography>
            <Typography variant="body2" sx={{ fontSize: 'clamp(12px, 13px, 14px)' }}>
              <span className="results">
                {shipData?.actual_delivery_date && shipData?.actual_delivery_date !== null
                  ? `Delivered on`
                  : `Planned Delivery`}
                <br />
                {shipData?.actual_delivery_date && shipData?.actual_delivery_date !== null
                  ? preferedDateFormat(shipData?.actual_delivery_date)
                  : preferedDateFormat(shipData?.date_of_delivery)}
              </span>
            </Typography>
          </Box>
        </Box>
      </AppModal>
    </>
  );
};

export default ShippedDialog;
